var _g;
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-64 -332) translate(40 40) translate(0 88) translate(24 204)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path_secondary",
    fill: "#98A6D6",
    d: "M19.743 13.023l-1.794-1.041c.181-.983.181-1.99 0-2.972l1.794-1.042c.205-.12.301-.365.232-.593-.464-1.49-1.25-2.858-2.304-4.005-.16-.175-.418-.215-.623-.097l-1.795 1.041c-.753-.652-1.622-1.156-2.56-1.486V.75c0-.237-.164-.443-.394-.495-1.515-.339-3.085-.339-4.6 0-.23.052-.395.257-.396.495v2.083c-.936.336-1.804.84-2.56 1.487L2.95 3.277c-.204-.12-.464-.08-.623.097C1.272 4.52.485 5.89.023 7.38c-.07.227.026.474.232.592l1.794 1.042c-.181.982-.181 1.99 0 2.972L.255 13.028c-.205.119-.301.365-.232.592.464 1.49 1.25 2.858 2.304 4.006.16.174.418.215.623.097l1.795-1.042c.753.653 1.622 1.157 2.56 1.487v2.083c0 .238.165.443.396.495 1.515.339 3.085.339 4.6 0 .231-.052.396-.257.396-.495v-2.083c.936-.336 1.804-.84 2.56-1.487l1.795 1.042c.205.12.465.08.623-.097 1.056-1.146 1.843-2.515 2.304-4.006.067-.23-.03-.475-.236-.597zm-9.746 1.533c-2.23 0-4.04-1.818-4.04-4.06 0-2.243 1.81-4.06 4.04-4.06s4.04 1.817 4.04 4.06c0 2.242-1.809 4.06-4.04 4.06z",
    transform: "translate(-64 -332) translate(40 40) translate(0 88) translate(24 204) translate(2 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_primary",
    fill: "#4C69BA",
    d: "M9.997 13.201c-1.486 0-2.691-1.211-2.691-2.705S8.51 7.79 9.997 7.79c1.486 0 2.691 1.212 2.691 2.706S11.483 13.2 9.997 13.2z",
    transform: "translate(-64 -332) translate(40 40) translate(0 88) translate(24 204) translate(2 1.5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.6ccf5278.svg";
export { ForwardRef as ReactComponent };